import { SimplePlotModel } from "../../../models/plotting";

export class DRIPlotModel extends SimplePlotModel {
  constructor(dataModel: any, plotTypeOptions: string[], chartId: string) {
    super(dataModel, plotTypeOptions, chartId);
    this.valueKey = "measurement_value";
    this.filterKey = "measurement_type";
    this.dateTimeKey = "measurement_datetime";
  }
}
